const shell = {
  projectSyncError: '暫時無法讀取企業專案，請檢查網路後重試。',
  retry: '重新嘗試',
  projectSwitcher: '專案切換器',
  switchWorkspace: '切換企業空間',
  home: 'Navigator 首頁',
  project: '專案',
  currentProject: '目前專案',
  newProject: '建立新專案',
  navigation: '一級導覽',
  nav: {
    memory: '記憶',
    diagnosis: '診斷',
    action: '行動',
    presence: '陣地',
    results: '結果',
  },
  appearance: '外觀',
  themeButtonLabel: '外觀 · {theme}',
  settings: '設定',
  settingsIntro: '管理介面、企業空間與專案偏好。',
  personal: '個人',
  workspace: '企業空間',
  projectSettings: '專案',
  interfaceLanguage: '介面語言',
  interfaceLanguageHint: '只切換 Navigator 控制項；企業真值與證據原文維持原語言。',
  followSystem: '跟隨系統',
  theme: '主題',
  themeSystem: '跟隨系統',
  themeLight: '淺色',
  themeDark: '深色',
  close: '關閉',
  vaultConnected: '專案空間已就緒',
  workspaceSettingsIntro: '管理這家企業共用的空間偏好。',
  membersEyebrow: '企業級存取控制',
  membersTitle: '成員與權限',
  membersIntro: '決定哪些工作信箱可以進入企業空間，以及每位成員能執行哪些工作。',
  membersScope: '權限適用於目前企業空間內的所有專案。',
  activeMembers: '名有效成員',
  memberRoles: { tenant_admin: '企業管理員', operator: '營運人員', member: '成員' },
  memberRoleShort: {
    tenant_admin: '管理成員、設定與全部營運工作。',
    operator: '處理線索、分配負責人與記錄跟進。',
    member: '使用企業專案並處理分配給自己的工作。',
  },
  memberRoleDetail: {
    tenant_admin: '可管理成員與設定、進入營運視圖，並將線索分配給其他成員。',
    operator: '可進入營運視圖、處理線索，並將線索分配給有效成員。',
    member: '可使用企業專案並處理自己的工作；不能管理成員。',
  },
  memberStatuses: { active: '有效', revoked: '已停用' },
  memberList: '企業成員',
  memberFilter: '成員篩選',
  addMember: '新增成員',
  manageMember: '管理',
  currentAccount: '目前帳號',
  noMembers: '目前狀態下沒有成員。',
  membersLoading: '正在讀取企業成員…',
  membersLoadFailed: '暫時無法讀取企業成員。',
  memberBoundaryTitle: 'V1 權限邊界：',
  memberBoundaryBody: '這裡只管理企業級存取，不建立部門或專案級權限。停用後，既有登入工作階段會立即失效。',
  memberPermissionTitle: '只有企業管理員可以管理成員。',
  memberPermissionBody: '你目前的存取權限不會改變。',
  addMemberTitle: '新增企業成員',
  addMemberIntro: '將工作信箱加入目前企業空間。',
  editMemberTitle: '管理成員',
  editMemberIntro: '角色變更會在儲存後立即生效。',
  workEmail: '工作信箱',
  memberEmailHint: '新增後，對方即可在登入頁申請一次性安全連結。',
  accessRole: '存取權限',
  memberLastAdminTitle: '最後一名管理員不能降級或停用。',
  memberLastAdminBody: '請先新增另一名企業管理員。',
  memberSelfGuard: '目前管理員不能修改自己的存取權限。',
  deactivateMember: '停用存取',
  restoreMember: '恢復存取',
  saveMember: '儲存變更',
  savingMember: '正在儲存…',
  cancel: '取消',
  memberAdded: '已新增成員。',
  memberSaved: '已更新成員權限。',
  memberRevoked: '已停用成員存取。',
  memberRestored: '已恢復成員存取。',
  memberExists: '此信箱已存在於企業空間。',
  memberSaveFailed: '無法儲存成員變更。',
  projectSettingsIntro: '管理只對目前專案生效的偏好。',
  defaultOutputLanguage: '預設工作與報告語言',
  defaultOutputLanguageHint: '診斷報告、策略及其他專案 AI 呼叫會把它作為具體 output_language 傳送；不會改變介面語言。',
  targetContentLanguages: '目標內容語言',
  targetContentLanguagesHint: '選擇一種或多種面向市場的生產語言；單次任務之後仍可覆寫專案預設值。',
  saveLanguageSettings: '儲存語言設定',
  savingLanguageSettings: '正在儲存…',
  languageSettingsSaved: '已儲存',
  languageSettingsFailed: '儲存失敗，正式設定仍維持原值。',
  leadSlaTenantTitle: '企業線索回應規則',
  leadSlaTenantHint: '設定企業專案預設採用的線索回應時限；專案可繼承、覆寫或停用。',
  leadSlaProjectTitle: '專案線索回應規則',
  leadSlaProjectHint: '決定目前專案繼承企業規則、使用獨立規則，或停用後續計時。',
  leadSlaLoading: '正在讀取目前回應規則…',
  leadSlaEffective: '目前生效',
  leadSlaEnabled: '已啟用',
  leadSlaDisabled: '已停用',
  leadSlaEffectiveSource: '來源：{source} · 規則 revision {revision}',
  leadSlaSourceTenant: '企業規則',
  leadSlaSourceProject: '專案規則',
  leadSlaSourceNone: '尚無規則',
  leadSlaMode: '目前層級',
  leadSlaModes: { policy: '使用獨立規則', disabled: '停用', inherit: '繼承企業規則' },
  leadSlaClockMode: '計時方式',
  leadSlaClockElapsed: '連續時間',
  leadSlaClockBusiness: '僅工作時段',
  leadSlaTimezone: '時區',
  leadSlaFirstResponse: '首次回應（分鐘）',
  leadSlaFollowup: '後續跟進（分鐘）',
  leadSlaWarning: '提前提醒（分鐘）',
  leadSlaBusinessDays: '工作日',
  leadSlaWeekdays: { 0: '週一', 1: '週二', 2: '週三', 3: '週四', 4: '週五', 5: '週六', 6: '週日' },
  leadSlaBusinessStart: '開始時間',
  leadSlaBusinessEnd: '結束時間',
  leadSlaAdminOnly: '只有企業管理員可以修改此設定。',
  leadSlaValidation: '請完整填寫規則；提醒時間必須短於首次回應與後續跟進時限。',
  leadSlaSave: '儲存回應規則',
  leadSlaSaving: '正在儲存…',
  leadSlaSaved: '回應規則已儲存',
  leadSlaSaveFailed: '儲存失敗，請重新讀取後再試。',
  leadSlaUnavailable: '暫時無法讀取目前回應規則。',
  leadSlaNoScope: '目前企業或專案尚不可用。',
  leadSlaClockBoundary: '設定變更不會改寫正在執行的計時：目前階段依啟動時規則結算；停用後不再開啟下一階段，繼承後下一階段採用屆時生效的企業規則。',
  airlockAppearance: '網站 Airlock 外觀',
  airlockAppearanceHint: '設定部署在客戶網站上的接待模組外觀，不會改變 Navigator 本身介面。',
  airlockLoading: '正在讀取網站目前外觀…',
  airlockPreviewEyebrow: '網站接待',
  airlockPreviewTitle: '有什麼可以幫你？',
  airlockPreviewBody: '儲存前預覽核准使用的色彩、圓角與字型。',
  airlockPreviewAction: '開始交流',
  airlockColorScheme: '深淺模式',
  airlockScheme: { auto: '跟隨訪客裝置', light: '永遠淺色', dark: '永遠深色' },
  airlockColors: '品牌色彩',
  airlockColorsHint: '保留「網站預設」時，Airlock 會使用經過驗證的安全預設值。',
  airlockAccent: '主要操作按鈕',
  airlockOnAccent: '主按鈕文字',
  airlockSurface: '主要背景',
  airlockSurfaceAlt: '次要背景',
  airlockText: '主要文字',
  airlockMuted: '輔助文字',
  airlockLine: '邊框與分隔線',
  airlockInherit: '網站預設',
  airlockUseDefault: '使用預設',
  airlockCornerRadius: '圓角大小',
  airlockFont: '字型',
  airlockFontHost: '跟隨網站',
  airlockFontSans: 'Navigator 無襯線',
  airlockFontSerif: 'Navigator 襯線',
  airlockSave: '儲存 Airlock 外觀',
  airlockSaving: '正在儲存…',
  airlockSaved: '網站外觀已儲存',
  airlockSaveFailed: '儲存失敗，請重新讀取目前設定後再試。',
  airlockUnavailable: '這個專案目前沒有可用的網站外觀設定。',
  airlockRetry: '重新讀取',
  airlockBoundary: '這裡只接受核准的色彩、圓角、字型與深淺模式；不能輸入自訂 CSS、網址或指令碼。',
  subscription: '訂閱與計費',
  billingLoading: '正在讀取訂閱狀態…',
  billingUnavailable: '目前無法使用訂閱計費服務。',
  billingEyebrow: '領航者計費 · Stripe 沙盒',
  billingTitle: '方案與訂閱',
  billingIntro: '為目前企業空間選擇持續運行的產能。領航者能力會持續進化；方案劃分的是使用容量，不是固定不變的功能清單。',
  billingSandbox: '測試模式 · 不會正式扣款',
  billingEnterprise: '付費企業空間',
  billingCurrent: '目前訂閱',
  billingStatus: {
    AWAITING_PAYMENT: '等待付款完成',
    ACTIVE: '生效中',
    CANCEL_AT_PERIOD_END: '本週期結束後停止',
    PAST_DUE: '付款逾期',
    EXPIRED: '已到期',
    REFUNDED: '已退款',
  },
  billingPeriodEnd: '目前週期至 {date}',
  billingNoSubscription: '目前企業空間尚無生效中的訂閱。',
  billingInterval: '付款週期',
  billingMonthly: '按月付費',
  billingAnnual: '按年付費',
  billingAnnualPromo: '付 10 個月，使用 12 個月',
  billingPlan: {
    launch: '適合開始建立持續成長循環的小型團隊。',
    growth: '適合持續拓展市場與工作循環的成長型團隊。',
    scale: '適合更高業務規模與複雜協作的組織。',
    enterprise: '依合約另行約定價格、部署邊界與服務條件。',
  },
  billingMonthUnit: '月',
  billingYearUnit: '年',
  billingStartCheckout: '前往安全付款',
  billingRedirecting: '正在開啟付款頁…',
  billingCustom: '按需定價',
  billingContractOnly: '聯絡我們',
  billingAdminOnly: '只有企業空間管理員可以發起訂閱。',
  billingExistingGuard: '目前空間已有訂閱；沙盒階段暫不開放自助改檔與取消。',
  billingCheckoutFailed: '未能開啟付款頁面，訂閱狀態沒有改變。',
  billingBoundary: '目前僅為測試環境。企業身分取自已登入的 Navigator 工作階段，價格取自鎖定的沙盒價目表；瀏覽器不能改寫這兩項。',
  billingUsageEyebrow: '容量觀察',
  billingUsageTitle: '本週期業務用量',
  billingUsageObserveOnly: '目前只記錄內測研究值，達到參考線也不會停機、降級或自動扣費。',
  billingUsageCounter: {
    completed_cycle: '完成週期',
    standard_artifact: '標準成果',
    localization_version: '在地化版本',
    publication_position: '新增發佈位置',
    airlock_conversation: 'Airlock AI 會話',
  },
  billingUsageBreakdown: '已用 {used} · 進行中 {inFlight} · 待佇列 {queued}',
  billingUsageNotConnected: '資料尚未接通',
  billingUsageNotConnectedDetail: '接通可信業務來源後，才會顯示真實用量。',
  billingUsageBoundary: '斜線後的數字是 Sandbox 觀察錨點，不是正式客戶合約額度。',
  outputLanguageBoundary: '語言選擇權屬於 Navigator；Foundry 每次只接收一個具體的 BCP-47 output_language，不定義全域預設語言。',
  settingsBoundary: '這裡承載面向客戶的應用設定與企業存取權限；內部營運和系統控制仍由獨立控制端負責。',
  settingsDeferred: '設定入口與所有權邊界已就位；具體欄位只會在正式契約核准後接入。',
  signedInAs: '目前登入信箱',
  signOut: '登出',
  signingOut: '正在登出…',
  signOutFailed: '登出失敗，請檢查網路後重試。',
  surfacePendingEyebrow: '全域殼 · 頁面接線',
  surfacePendingTitle: '{route}頁面正在接入',
  surfacePendingBody: '導覽、語言與設定邊界已就位；本頁將在對應頁面批次中接入正式內容。',
} as const

export default shell
